module.exports = __webpack_public_path__ + "static/media/icon-supplies-alcohol-wipes.ca9a3f69.svg";